import { useContext } from 'react'

import { GeckoAuthContext } from './geckoAuthContext'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from './permissions/rolodexPermissionsList'

export const useEasterEggs = () => {
  const context = useContext(GeckoAuthContext)
  const today = new Date()
  // April 1st - month is zero indexed, date is not ಠ_ಠ
  const isAprilFools = today.getMonth() === 3 && today.getDate() === 1
  const isInternalAprilFools =
    context?.hasPermissions([PERMISSION_GECKO_INTERNAL_MEMBER]) && isAprilFools
  return { isInternalAprilFools, isAprilFools }
}
